import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

import lobbyReducers from "../reducers"

// `handlesOwnErrors`: both callers — the join dialog and the invite screen — render the refusal
// themselves, against the field it is about. Without it the interceptor adds axios's own "Request
// failed with status code 400" beside them, which names neither the lobby nor the reason.
export const thunk = createAsyncThunk("lobby/joinLobby", async (data, { rejectWithValue }) => {
  try {
    const response = await apiClient.post(
      `/lobby/${data.number}/join/`,
      { password: data.password },
      { handlesOwnErrors: true }
    )
    return [response.data]
  } catch (error) {
    // Optional: a request that never got an answer has no `data` to reject with, and reading
    // through it turned a dead server into a TypeError inside the thunk.
    return rejectWithValue(error.response?.data)
  }
})

export const onSucceed = lobbyReducers.setLobbies

const thunkObject = { thunk, onSucceed }
export default thunkObject
